import React from 'react'
import css from './EmptyState.styles.scss'

const EmptyState: React.FC = () => (
  <div className={css.EmptyState}>
    <p className={css.EmptyState__title}>No shipments, yet.</p>
    <p className={css.EmptyState__subtitle}>
      Soon you'll be unboxing teeny, tiny, baby onesies! 😍
    </p>
  </div>
)

export default EmptyState
